import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { apiError } from "../../lib/api";
import { Wordmark } from "../../components/Wordmark";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-plexus px-6" data-testid="admin-login">
      <div className="brand-card w-full max-w-md p-8">
        <Link to="/" className="no-underline"><Wordmark style={{ fontSize: 24 }} /></Link>
        <h1 className="mt-6 text-3xl">Admin sign in</h1>
        <p className="mt-1 text-[14px] text-text-muted">Publish and manage your setups.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="field-label">Email</label>
            <input type="email" className="brand-input" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email" />
          </div>
          <div>
            <label className="field-label">Password</label>
            <input type="password" className="brand-input" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password" />
          </div>
          {error && <p className="text-[14px] font-semibold text-brick" data-testid="admin-login-error">{error}</p>}
          <button type="submit" className="btn btn-primary w-full" disabled={loading} data-testid="admin-login-submit">
            {loading ? <Loader2 className="animate-spin" size={16} /> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
